<template>
	<div class="container">
		<ul
			v-for="(menu, menu_idx) in mobileMainMenuList"
			:key="menu_idx"
			:class="['menu', { last: menu_idx === mobileMainMenuList.length - 1 }]"
		>
			<li class="menu_title_main">
				<div class="title_icon">
					<IconBase v-if="menu.icon" width="28" height="28" icon-name="대표메뉴"
						><component :is="menu.icon" v-if="menu.icon"></component>
					</IconBase>
					<img v-else src="@/assets/img/common/mypage.png" alt="mypage" loading="lazy" />
				</div>
				<span class="menu_title_txt">{{ menu.title }}</span>
			</li>

			<div
				v-for="(item, index) in menu.subMenu"
				:key="index"
				target="_self"
				class="menu_title_side cursor-pointer"
				:class="{ on: headerStore.getSelectedMenu === item.group }"
				@click.prevent.stop="onMenuClick(item.path, item.group)"
			>
				<div class="sub_title">
					{{ item.title }}
					<div v-if="item.isHot" class="c_tag color-red">HOT</div>
					<div v-if="item.isPremium" class="c_tag color-yellow">프리미엄</div>
				</div>
				<IconArrowNext width="20" height="20" icon-color="#C6C6D6" class="arrow_next" />
			</div>
		</ul>
	</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

import { useGetCheckTokenApi } from '@/api/auth';
// api
import IconArrowNext from '@/components/atom/icon/IconArrowNext.vue';
// component
import IconBase from '@/components/atom/icon/IconBase.vue';
// constant
import { mobileMainMenuList } from '@/constants/menu';
import { CANCEL, CONFIRM_LOGIN, LOGIN_REQUIRED_PAGE } from '@/constants/title';
// store
import { useHeaderStore } from '@/stores/header';
import { useLoginPopupStore } from '@/stores/LoginPopup';
import { useTokenStore } from '@/stores/token';
// util
import { moveToLink } from '@/utils/function/deviceTypeNative';

const headerStore = useHeaderStore();
const tokenStore = useTokenStore();
const loginPopupStore = useLoginPopupStore();

const router = useRouter();
const { refetch: checkTokenRefetch } = useGetCheckTokenApi();

// 메뉴 클릭 시
const onMenuClick = async (path: string, group: string) => {
	if (group === 'Mall') {
		if (!tokenStore.isLogin) {
			loginPopupStore.openPopup({
				icon: 'alert',
				content: LOGIN_REQUIRED_PAGE,
				confirm: () => router.push('/auth/login'),
				confirmText: CONFIRM_LOGIN,
				cancelText: CANCEL,
			});
			return;
		}
		const res = await checkTokenRefetch();
		if (!res.data?.success) {
			if (String(res.data?.error.code) === String(97) || String(res.data?.error.code) === String(91)) {
				return;
			}
		} else {
			const url = `${import.meta.env.VITE_MALL_URL}/?access_token=${tokenStore.getAccessToken}`;
			moveToLink(url);
		}

		return;
	}
	router.push({ path });
};
</script>

<style lang="scss" scoped>
.menu {
	padding: 1.6rem 0rem;
	border-bottom: 1px solid var(--color-base-mid-dark);
	&_title_main {
		display: flex;
		align-items: center;
		gap: 0.8rem;
		font-size: var(--font-s-large);
		font-weight: var(--font-w-bold);
		line-height: 2.5rem;
		padding: 1rem 0rem;
		cursor: pointer;
		.title_icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 2.8rem;
			height: 2.8rem;
			object-fit: contain;
			svg {
				width: 100%;
				height: 100%;
			}
		}
	}
	.menu_title_main {
		cursor: auto;
	}
	.menu_title_side {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 1.6rem 0rem;
		justify-content: space-between;
		font-weight: var(--font-w-semi-bold);
		font-size: var(--font-s-mid);
		line-height: normal;
		.sub_title {
			display: flex;
			gap: 0.8rem;
			white-space: nowrap;
			.c_tag {
				border-radius: 0.4rem;
				font-weight: var(--font-w-semi-bold);
				line-height: normal;
			}
		}
		img {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 2rem;
			height: 2rem;
			object-fit: contain;
		}
	}
}
.last {
	border-bottom: none;
	padding-bottom: 0rem;
}
</style>
